'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currencySignFormatter = undefined;

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CURRENCY_SIGN_DATA_MAP = new _map2.default([['EUR', { sign: '€', isPrefix: false }], ['USD', { sign: '$', isPrefix: true }], ['GBP', { sign: '£', isPrefix: true }], ['AUD', { sign: 'A $', isPrefix: true }], ['CHF', { sign: 'CHF ', isPrefix: true }], ['HKD', { sign: 'HK $', isPrefix: true }], ['SGD', { sign: 'S $', isPrefix: true }], ['JPY', { sign: '¥', isPrefix: true }], ['DKK', { sign: 'DKK ', isPrefix: true }], ['CAD', { sign: 'C $', isPrefix: true }], ['SEK', { sign: 'SEK ', isPrefix: true }]]);

var currencySignFormatter = exports.currencySignFormatter = function currencySignFormatter(value, currencyCode) {
  var currencySignData = CURRENCY_SIGN_DATA_MAP.get(currencyCode);
  if (currencySignData && value) {
    return currencySignData.isPrefix ? [currencySignData.sign, value] : [value, ' ' + currencySignData.sign];
  }
  return [value];
};